import axios from "axios";
import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store"

class MailForwardService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }
    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    get(isActive) {
        return Vue.axios.get(`${APIHOST}/api/MailForward`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                isActive: isActive
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    postMailsForward(mailForwardTask) {
        return Vue.axios.post(
            `${APIHOST}/api/MailForward`,
            mailForwardTask,
            {
                headers: {
                    Authorization: `Bearer ${$store.getters.accessToken}`,
                    "Content-Type": "application/json",
                },
                cancelToken: this.cancelTokenSource.token,
            }
        );
    }

    post({clientType, regionId, areaId, address, receiver, forwardedRegionId, forwardedAreaId, forwardedPostCode, forwardedAddress}) {
        return Vue.axios.post(`${APIHOST}/api/MailForward`, {
                ClientType : clientType,
                RegionId : regionId,
                AreaId : areaId,
                Address : address,
                Receiver : receiver,
                ForwardedRegionId : forwardedRegionId,
                ForwardedAreaId : forwardedAreaId,
                ForwardedPostCode : forwardedPostCode,
                ForwardedAddress : forwardedAddress,
            },
            {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                }
            })
    }

    put(id, isActive) {
        return Vue.axios.put(`${APIHOST}/api/MailForward`, {}, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            params: {
                id: id,
                isActive: isActive
            }
        })
    }

    delete(id) {
        return Vue.axios.delete(`${APIHOST}/api/MailForward`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            }
        })
    }

}

export default new MailForwardService();
